import React from 'react';
import * as dates from '@simplybenefits/sb-dates';
import Text from '../../../../components/Text.js';
import { colors } from '../../../../theme/index.js';
import { styled } from '@mui/system';
import i18n from '../../../../localization/i18n.js';
import tokens from '../../../../localization/tokens.js';
import * as localizationMaps from '../../../../localization/maps.js';
const StyledContainer = styled('div')(({
  theme
}) => ({
  boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.15)',
  background: '#FFF',
  width: '254px',
  // 336,
  height: '240px',
  // 315,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  margin: '8px',
  position: 'relative',
  '&:hover': {
    boxShadow: '0px 12px 40px rgba(0, 0, 0, 0.15)'
  }
}));

/**
 * @param number
 * @returns {string}
 * @private
 */
const _formatNumber = number => `$${(number || 0).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;

/**
 * 
 */
const setDescription = (isCurrentAllocation, isFirstInvoice, date) => {
  if (isCurrentAllocation) {
    return /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      display: "block",
      align: "center",
      marginBottom: 20
    }, i18n.t(tokens.labels.invoices.currentAllocation));
  }
  if (isFirstInvoice) {
    return /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      display: "block",
      align: "center",
      marginBottom: 20
    }, i18n.t(tokens.labels.invoices.censusBilling));
  }
  return /*#__PURE__*/React.createElement(Text, {
    medium: true,
    display: "block",
    align: "center",
    marginBottom: 20
  }, dates.getLocalDisplay(date, 'MMMM YYYY', i18n.locale));
};

/**
 * @param total
 * @param date
 * @param status
 * @param onClick
 * @param classes
 * @param id
 * @param testid
 * @param isFirstInvoice
 * @returns {*}
 * @constructor
 */
const InvoiceTile = ({
  total,
  date,
  status,
  onClick,
  id,
  testid,
  isFirstInvoice = false,
  isCurrentAllocation = false,
  whitelabel = {}
}) => /*#__PURE__*/React.createElement(StyledContainer, {
  id: id || testid,
  onClick: onClick
}, setDescription(isCurrentAllocation, isFirstInvoice, date) // get the date the bill was created (minus 1 month) to get the actual month the bill was for
, isCurrentAllocation ? /*#__PURE__*/React.createElement(Text, {
  tiny: true,
  display: "block",
  align: "center",
  margin: "10px 20px 15px"
}, i18n.t(tokens.labels.invoices.nextChargePhrase)) : /*#__PURE__*/React.createElement(Text, {
  extraLarge: true,
  bold: true,
  display: "block",
  align: "center"
}, _formatNumber(total)), /*#__PURE__*/React.createElement(Text, {
  medium: true,
  color: status === 'Paid' ? colors.brandGreen : status === 'Failed' ? colors.red : whitelabel.primaryColor || colors.darkBlue,
  display: "block",
  align: "center",
  uppercase: true,
  bold: true
}, status === 'Pending' ? localizationMaps.fromEnglish("invoiceStatuses", status) : ''));
export default InvoiceTile;